import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Reauth/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Reauth/Clauses/types';

// State type
export interface ReauthState {
  static: StaticState;
  process: ProcessState;
}

interface StaticState {
  memberProfile?: MbGetinfoResp;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  clauses: {
    data?: ClausesFormValues;
  };
  otpAuth: {
    otp?: AaOtpSendcodeResp;
  };
}
// ::: End

// Actions type constant
export const MEMBER_REAUTH__SAVE_MEMBER_PROFILE = 'MEMBER_REAUTH__SAVE_MEMBER_PROFILE';
export const MEMBER_REAUTH__SET_ACCESSIBLE_STEP = 'MEMBER_REAUTH__SET_ACCESSIBLE_STEP';
export const MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA = 'MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA';
export const MEMBER_REAUTH__SEND_OTP = 'MEMBER_REAUTH__SEND_OTP';
export const MEMBER_REAUTH__SEND_OTP_DONE = 'MEMBER_REAUTH__SEND_OTP_DONE';
export const MEMBER_REAUTH__AUTH_OTP = 'MEMBER_REAUTH__AUTH_OTP';
export const MEMBER_REAUTH__UPDATE_CACHE = 'MEMBER_REAUTH__UPDATE_CACHE';
export const MEMBER_REAUTH__RESET_CACHE = 'MEMBER_REAUTH__RESET_CACHE';
// ::: End

// Action creators type
export interface SaveMemberProfileAction {
  type: typeof MEMBER_REAUTH__SAVE_MEMBER_PROFILE;
  payload: {
    data: MbGetinfoResp;
  };
}

export interface SetAccessibleStepAction {
  type: typeof MEMBER_REAUTH__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SaveClausesPageDataAction {
  type: typeof MEMBER_REAUTH__SAVE_CLAUSES_PAGE_DATA;
  payload: {
    data: ClausesFormValues;
  };
}

export interface SendOTPAction {
  type: typeof MEMBER_REAUTH__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
    redirectRoute?: ROUTES;
  };
}

export interface SendOTPDoneAction {
  type: typeof MEMBER_REAUTH__SEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthOTPAction {
  type: typeof MEMBER_REAUTH__AUTH_OTP;
  payload: {
    args: AaOtpVerifyReq;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_REAUTH__UPDATE_CACHE;
  payload: {
    cache: ReauthState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_REAUTH__RESET_CACHE;
}

export type ReauthActions =
    SaveMemberProfileAction
  | SetAccessibleStepAction
  | SaveClausesPageDataAction
  | SendOTPAction
  | SendOTPDoneAction
  | AuthOTPAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
